import React, { Component } from 'react';
import { Table, Form } from 'react-bootstrap';
import { concepts_payroll } from '../localdata/conceptos';


class GeneralOneValueForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: 0,
            name: ''
        };
    }
    componentDidMount() { }

    updateInfo = ({ target }) => {
        const { returnData, concept } = this.props;
        const current_value = (target.value !== '') ? parseFloat(target.value) : '';
        returnData({
            value: current_value,
            total_line: current_value,
            code: concept,
            quantity: 1
        })
        this.setState({ value: current_value })
    }
    render() {
        const { concept } = this.props;
        const infoConcept = concepts_payroll.find((c) => c.code === concept)
        const cleanName = infoConcept.description.substring(
            infoConcept.description.indexOf('-') + 1
        ).trim()
        return (
            <Table striped bordered size="sm">
                <thead>
                    <tr>
                        <td>TIPO</td>
                        <td>VALOR</td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{cleanName}</td>
                        <td><Form.Control className='mediuminput' type="number" min={0} placeholder="Ingrese la cantidad" name="value" value={this.state.value} onChange={(e) => this.updateInfo(e)}></Form.Control></td>
                    </tr>
                </tbody>
            </Table>
        );
    }
}
export default (GeneralOneValueForm);


// WEBPACK FOOTER //
// ./src/components/nomina/subcomponents/generalOneValueForm.jsx